const STRINGS = {
	optional: gettext('Optional'),
	invalidSelection: gettext('A choice is required'),
	requiredField: gettext('This field is required'),
	requiredChoice: gettext('Please select a valid choice.'),
	emailMaxLengthError: gettext('This field cannot exceed 254 characters.'),
	invalidEmail: gettext('Please enter a valid email address.'),
	textFieldMaxLengthError: gettext('This field cannot exceed 255 characters.'),
	invalidNumber: gettext('Please enter a valid number.'),
	invalidURL: gettext('Please enter a valid URL.'),
	longTextFieldMaxLengthError: gettext('This field cannot exceed 512 characters.'),
};

const CustomFieldTypes = {
	Text: 0,
	Choice: 1,
	Email: 2,
	Integer: 3,
	Decimal: 4,
	Slug: 5,
	URL: 6,
	LongText: 7,
	Date: 8,
}

export {
	STRINGS,
	CustomFieldTypes,
}